export default __webpack_public_path__ + "static/media/music.19cabe1b.mp3";